export { SpanStatusCode } from '@opentelemetry/api';
export { ExportResultCode } from '@opentelemetry/core';
// Custom exporters and readers types
export { PeriodicExportingMetricReader } from '@opentelemetry/sdk-metrics';
//# sourceMappingURL=types.js.map